import { NavLink } from 'react-router-dom'
import { ReactNode } from 'react'
import { cn } from '@/lib/utils.ts'
import Count from '@/components/ui/Count.tsx'

type PropsT = {
  label: string
  icon: ReactNode
  to?: string
  onClick?: () => void
  isActive?: boolean
  badge?: number | null
  badgeVariant?: 'dark' | 'muted'
  dataCy?: string
}

export default function BottomTabBarItem({
  label,
  icon,
  to,
  onClick,
  isActive,
  badge,
  badgeVariant = 'dark',
  dataCy,
}: PropsT) {
  const content = (active: boolean) => (
    <>
      <div className={`relative flex h-6 items-center justify-center`}>
        {icon}
        {!!badge && badge > 0 && (
          <Count
            quantity={badge}
            variant={badgeVariant}
            className={`absolute -right-2.5 -top-1 ml-0`}
          />
        )}
      </div>
      <span
        className={cn(
          `max-w-full truncate text-[0.6875rem] leading-none`,
          active ? `font-medium text-foreground` : `text-muted-foreground`,
        )}
      >
        {label}
      </span>
    </>
  )

  const classes = (active: boolean) =>
    cn(
      `flex min-w-0 flex-1 flex-col items-center justify-center gap-1 px-1 py-1.5`,
      active ? `text-foreground` : `text-muted-foreground`,
    )

  if (to) {
    return (
      <NavLink
        to={to}
        data-cy={dataCy}
        end={false}
        className={({ isActive: routerActive }) => classes(isActive ?? routerActive)}
      >
        {({ isActive: routerActive }) => content(isActive ?? routerActive)}
      </NavLink>
    )
  }

  return (
    <button type="button" onClick={onClick} data-cy={dataCy} className={classes(!!isActive)}>
      {content(!!isActive)}
    </button>
  )
}
